/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addCoupon } from '../fn/coupons/add-coupon';
import { AddCoupon$Params } from '../fn/coupons/add-coupon';
import { AutoApplyCouponsList } from '../models/auto-apply-coupons-list';
import { CouponCodesHalResponse } from '../models/coupon-codes-hal-response';
import { CouponHalResponse } from '../models/coupon-hal-response';
import { couponsAutoApplyCouponIdDelete } from '../fn/coupons/coupons-auto-apply-coupon-id-delete';
import { CouponsAutoApplyCouponIdDelete$Params } from '../fn/coupons/coupons-auto-apply-coupon-id-delete';
import { couponsAutoApplyCouponIdPut } from '../fn/coupons/coupons-auto-apply-coupon-id-put';
import { CouponsAutoApplyCouponIdPut$Params } from '../fn/coupons/coupons-auto-apply-coupon-id-put';
import { couponsAutoApplyGet } from '../fn/coupons/coupons-auto-apply-get';
import { CouponsAutoApplyGet$Params } from '../fn/coupons/coupons-auto-apply-get';
import { couponsAutoApplyPost } from '../fn/coupons/coupons-auto-apply-post';
import { CouponsAutoApplyPost$Params } from '../fn/coupons/coupons-auto-apply-post';
import { couponsCodeCodeGet } from '../fn/coupons/coupons-code-code-get';
import { CouponsCodeCodeGet$Params } from '../fn/coupons/coupons-code-code-get';
import { couponsCouponIdCodesGet } from '../fn/coupons/coupons-coupon-id-codes-get';
import { CouponsCouponIdCodesGet$Params } from '../fn/coupons/coupons-coupon-id-codes-get';
import { couponsCouponIdGet } from '../fn/coupons/coupons-coupon-id-get';
import { CouponsCouponIdGet$Params } from '../fn/coupons/coupons-coupon-id-get';
import { couponsCouponIdPut } from '../fn/coupons/coupons-coupon-id-put';
import { CouponsCouponIdPut$Params } from '../fn/coupons/coupons-coupon-id-put';
import { couponsCouponIdUserProvidedCodesGet } from '../fn/coupons/coupons-coupon-id-user-provided-codes-get';
import { CouponsCouponIdUserProvidedCodesGet$Params } from '../fn/coupons/coupons-coupon-id-user-provided-codes-get';
import { couponsCouponIdUserProvidedCodesPut } from '../fn/coupons/coupons-coupon-id-user-provided-codes-put';
import { CouponsCouponIdUserProvidedCodesPut$Params } from '../fn/coupons/coupons-coupon-id-user-provided-codes-put';
import { couponsGet } from '../fn/coupons/coupons-get';
import { CouponsGet$Params } from '../fn/coupons/coupons-get';
import { CouponsHalResponse } from '../models/coupons-hal-response';
import { couponsIdGet } from '../fn/coupons/coupons-id-get';
import { CouponsIdGet$Params } from '../fn/coupons/coupons-id-get';
import { couponsPost } from '../fn/coupons/coupons-post';
import { CouponsPost$Params } from '../fn/coupons/coupons-post';
import { CouponSummaryResponse } from '../models/coupon-summary-response';
import { deleteCouponById } from '../fn/coupons/delete-coupon-by-id';
import { DeleteCouponById$Params } from '../fn/coupons/delete-coupon-by-id';
import { Empty } from '../models/empty';
import { getCouponById } from '../fn/coupons/get-coupon-by-id';
import { GetCouponById$Params } from '../fn/coupons/get-coupon-by-id';
import { getCoupons } from '../fn/coupons/get-coupons';
import { GetCoupons$Params } from '../fn/coupons/get-coupons';
import { getCouponSummary } from '../fn/coupons/get-coupon-summary';
import { GetCouponSummary$Params } from '../fn/coupons/get-coupon-summary';
import { getRedemptions } from '../fn/coupons/get-redemptions';
import { GetRedemptions$Params } from '../fn/coupons/get-redemptions';
import { getRedemptionSummaries } from '../fn/coupons/get-redemption-summaries';
import { GetRedemptionSummaries$Params } from '../fn/coupons/get-redemption-summaries';
import { PagedRedemptionsResponse } from '../models/paged-redemptions-response';
import { PagedRedemptionSummaryResponse } from '../models/paged-redemption-summary-response';
import { PaginatedCouponResponse } from '../models/paginated-coupon-response';
import { ProvidedCouponCodesHalResponse } from '../models/provided-coupon-codes-hal-response';
import { updateCouponById } from '../fn/coupons/update-coupon-by-id';
import { UpdateCouponById$Params } from '../fn/coupons/update-coupon-by-id';
import { WalletCouponHalResponse } from '../models/wallet-coupon-hal-response';
import { WalletCouponsHalResponse } from '../models/wallet-coupons-hal-response';

@Injectable({ providedIn: 'root' })
export class CouponsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `couponsGet()` */
  static readonly CouponsGetPath = '/coupons';

  /**
   * Retuns a list of coupons based on the filter criteria.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `couponsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  couponsGet$Response(params: CouponsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedCouponResponse>> {
    return couponsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Retuns a list of coupons based on the filter criteria.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `couponsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  couponsGet(params: CouponsGet$Params, context?: HttpContext): Observable<PaginatedCouponResponse> {
    return this.couponsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginatedCouponResponse>): PaginatedCouponResponse => r.body)
    );
  }

  /** Path part for operation `couponsPost()` */
  static readonly CouponsPostPath = '/coupons';

  /**
   * Creates a new coupon.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `couponsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  couponsPost$Response(params: CouponsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponHalResponse>> {
    return couponsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new coupon.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `couponsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  couponsPost(params: CouponsPost$Params, context?: HttpContext): Observable<CouponHalResponse> {
    return this.couponsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CouponHalResponse>): CouponHalResponse => r.body)
    );
  }

  /** Path part for operation `couponsCouponIdGet()` */
  static readonly CouponsCouponIdGetPath = '/coupons/{couponId}';

  /**
   * Retuns a coupon based on the couponId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `couponsCouponIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  couponsCouponIdGet$Response(params: CouponsCouponIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponHalResponse>> {
    return couponsCouponIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Retuns a coupon based on the couponId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `couponsCouponIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  couponsCouponIdGet(params: CouponsCouponIdGet$Params, context?: HttpContext): Observable<CouponHalResponse> {
    return this.couponsCouponIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CouponHalResponse>): CouponHalResponse => r.body)
    );
  }

  /** Path part for operation `couponsCouponIdPut()` */
  static readonly CouponsCouponIdPutPath = '/coupons/{couponId}';

  /**
   * Updates a coupon.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `couponsCouponIdPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  couponsCouponIdPut$Response(params: CouponsCouponIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponHalResponse>> {
    return couponsCouponIdPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates a coupon.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `couponsCouponIdPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  couponsCouponIdPut(params: CouponsCouponIdPut$Params, context?: HttpContext): Observable<CouponHalResponse> {
    return this.couponsCouponIdPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CouponHalResponse>): CouponHalResponse => r.body)
    );
  }

  /** Path part for operation `couponsIdGet()` */
  static readonly CouponsIdGetPath = '/coupons/id';

  /**
   * Retuns coupons based on matching couponIds in the query string.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `couponsIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  couponsIdGet$Response(params: CouponsIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponsHalResponse>> {
    return couponsIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Retuns coupons based on matching couponIds in the query string.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `couponsIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  couponsIdGet(params: CouponsIdGet$Params, context?: HttpContext): Observable<CouponsHalResponse> {
    return this.couponsIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CouponsHalResponse>): CouponsHalResponse => r.body)
    );
  }

  /** Path part for operation `couponsCouponIdCodesGet()` */
  static readonly CouponsCouponIdCodesGetPath = '/coupons/{couponId}/codes';

  /**
   * returns the codes for a coupon.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `couponsCouponIdCodesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  couponsCouponIdCodesGet$Response(params: CouponsCouponIdCodesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponCodesHalResponse>> {
    return couponsCouponIdCodesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * returns the codes for a coupon.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `couponsCouponIdCodesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  couponsCouponIdCodesGet(params: CouponsCouponIdCodesGet$Params, context?: HttpContext): Observable<CouponCodesHalResponse> {
    return this.couponsCouponIdCodesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CouponCodesHalResponse>): CouponCodesHalResponse => r.body)
    );
  }

  /** Path part for operation `couponsCouponIdUserProvidedCodesGet()` */
  static readonly CouponsCouponIdUserProvidedCodesGetPath = '/coupons/{couponId}/user-provided-codes';

  /**
   * returns the user provided codes for a coupon.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `couponsCouponIdUserProvidedCodesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  couponsCouponIdUserProvidedCodesGet$Response(params: CouponsCouponIdUserProvidedCodesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ProvidedCouponCodesHalResponse>> {
    return couponsCouponIdUserProvidedCodesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * returns the user provided codes for a coupon.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `couponsCouponIdUserProvidedCodesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  couponsCouponIdUserProvidedCodesGet(params: CouponsCouponIdUserProvidedCodesGet$Params, context?: HttpContext): Observable<ProvidedCouponCodesHalResponse> {
    return this.couponsCouponIdUserProvidedCodesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProvidedCouponCodesHalResponse>): ProvidedCouponCodesHalResponse => r.body)
    );
  }

  /** Path part for operation `couponsCouponIdUserProvidedCodesPut()` */
  static readonly CouponsCouponIdUserProvidedCodesPutPath = '/coupons/{couponId}/user-provided-codes';

  /**
   * Updates a coupon with the user provided codes.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `couponsCouponIdUserProvidedCodesPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  couponsCouponIdUserProvidedCodesPut$Response(params: CouponsCouponIdUserProvidedCodesPut$Params, context?: HttpContext): Observable<StrictHttpResponse<ProvidedCouponCodesHalResponse>> {
    return couponsCouponIdUserProvidedCodesPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates a coupon with the user provided codes.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `couponsCouponIdUserProvidedCodesPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  couponsCouponIdUserProvidedCodesPut(params: CouponsCouponIdUserProvidedCodesPut$Params, context?: HttpContext): Observable<ProvidedCouponCodesHalResponse> {
    return this.couponsCouponIdUserProvidedCodesPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProvidedCouponCodesHalResponse>): ProvidedCouponCodesHalResponse => r.body)
    );
  }

  /** Path part for operation `couponsCodeCodeGet()` */
  static readonly CouponsCodeCodeGetPath = '/coupons/code/{code}';

  /**
   * Retuns coupons based on the coupon code.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `couponsCodeCodeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  couponsCodeCodeGet$Response(params: CouponsCodeCodeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponsHalResponse>> {
    return couponsCodeCodeGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Retuns coupons based on the coupon code.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `couponsCodeCodeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  couponsCodeCodeGet(params: CouponsCodeCodeGet$Params, context?: HttpContext): Observable<CouponsHalResponse> {
    return this.couponsCodeCodeGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CouponsHalResponse>): CouponsHalResponse => r.body)
    );
  }

  /** Path part for operation `couponsAutoApplyGet()` */
  static readonly CouponsAutoApplyGetPath = '/coupons/auto-apply';

  /**
   * Retuns all auto apply coupons configured for the tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `couponsAutoApplyGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  couponsAutoApplyGet$Response(params: CouponsAutoApplyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AutoApplyCouponsList>> {
    return couponsAutoApplyGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Retuns all auto apply coupons configured for the tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `couponsAutoApplyGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  couponsAutoApplyGet(params: CouponsAutoApplyGet$Params, context?: HttpContext): Observable<AutoApplyCouponsList> {
    return this.couponsAutoApplyGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<AutoApplyCouponsList>): AutoApplyCouponsList => r.body)
    );
  }

  /** Path part for operation `couponsAutoApplyPost()` */
  static readonly CouponsAutoApplyPostPath = '/coupons/auto-apply';

  /**
   * Adds 1 or more auto apply coupons.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `couponsAutoApplyPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  couponsAutoApplyPost$Response(params: CouponsAutoApplyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AutoApplyCouponsList>> {
    return couponsAutoApplyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Adds 1 or more auto apply coupons.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `couponsAutoApplyPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  couponsAutoApplyPost(params: CouponsAutoApplyPost$Params, context?: HttpContext): Observable<AutoApplyCouponsList> {
    return this.couponsAutoApplyPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AutoApplyCouponsList>): AutoApplyCouponsList => r.body)
    );
  }

  /** Path part for operation `couponsAutoApplyCouponIdPut()` */
  static readonly CouponsAutoApplyCouponIdPutPath = '/coupons/auto-apply/{couponId}';

  /**
   * Updates a specific auto applied coupon.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `couponsAutoApplyCouponIdPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  couponsAutoApplyCouponIdPut$Response(params: CouponsAutoApplyCouponIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<Empty>> {
    return couponsAutoApplyCouponIdPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates a specific auto applied coupon.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `couponsAutoApplyCouponIdPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  couponsAutoApplyCouponIdPut(params: CouponsAutoApplyCouponIdPut$Params, context?: HttpContext): Observable<Empty> {
    return this.couponsAutoApplyCouponIdPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<Empty>): Empty => r.body)
    );
  }

  /** Path part for operation `couponsAutoApplyCouponIdDelete()` */
  static readonly CouponsAutoApplyCouponIdDeletePath = '/coupons/auto-apply/{couponId}';

  /**
   * Removes a specific coupon from being auto applied.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `couponsAutoApplyCouponIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  couponsAutoApplyCouponIdDelete$Response(params: CouponsAutoApplyCouponIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<Empty>> {
    return couponsAutoApplyCouponIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Removes a specific coupon from being auto applied.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `couponsAutoApplyCouponIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  couponsAutoApplyCouponIdDelete(params: CouponsAutoApplyCouponIdDelete$Params, context?: HttpContext): Observable<Empty> {
    return this.couponsAutoApplyCouponIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<Empty>): Empty => r.body)
    );
  }

  /** Path part for operation `getCouponSummary()` */
  static readonly GetCouponSummaryPath = '/redemptions/coupon/{couponId}/summary';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCouponSummary()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCouponSummary$Response(params: GetCouponSummary$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponSummaryResponse>> {
    return getCouponSummary(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCouponSummary$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCouponSummary(params: GetCouponSummary$Params, context?: HttpContext): Observable<CouponSummaryResponse> {
    return this.getCouponSummary$Response(params, context).pipe(
      map((r: StrictHttpResponse<CouponSummaryResponse>): CouponSummaryResponse => r.body)
    );
  }

  /** Path part for operation `getRedemptionSummaries()` */
  static readonly GetRedemptionSummariesPath = '/redemptionSummaries';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRedemptionSummaries()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRedemptionSummaries$Response(params?: GetRedemptionSummaries$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedRedemptionSummaryResponse>> {
    return getRedemptionSummaries(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRedemptionSummaries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRedemptionSummaries(params?: GetRedemptionSummaries$Params, context?: HttpContext): Observable<PagedRedemptionSummaryResponse> {
    return this.getRedemptionSummaries$Response(params, context).pipe(
      map((r: StrictHttpResponse<PagedRedemptionSummaryResponse>): PagedRedemptionSummaryResponse => r.body)
    );
  }

  /** Path part for operation `getRedemptions()` */
  static readonly GetRedemptionsPath = '/redemptions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRedemptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRedemptions$Response(params: GetRedemptions$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedRedemptionsResponse>> {
    return getRedemptions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRedemptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRedemptions(params: GetRedemptions$Params, context?: HttpContext): Observable<PagedRedemptionsResponse> {
    return this.getRedemptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<PagedRedemptionsResponse>): PagedRedemptionsResponse => r.body)
    );
  }

  /** Path part for operation `getCoupons()` */
  static readonly GetCouponsPath = '/wallet/coupons';

  /**
   * Get All Coupons
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCoupons()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCoupons$Response(params: GetCoupons$Params, context?: HttpContext): Observable<StrictHttpResponse<WalletCouponsHalResponse>> {
    return getCoupons(this.http, this.rootUrl, params, context);
  }

  /**
   * Get All Coupons
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCoupons$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCoupons(params: GetCoupons$Params, context?: HttpContext): Observable<WalletCouponsHalResponse> {
    return this.getCoupons$Response(params, context).pipe(
      map((r: StrictHttpResponse<WalletCouponsHalResponse>): WalletCouponsHalResponse => r.body)
    );
  }

  /** Path part for operation `addCoupon()` */
  static readonly AddCouponPath = '/wallet/coupons';

  /**
   * Add a Coupon
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addCoupon()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addCoupon$Response(params: AddCoupon$Params, context?: HttpContext): Observable<StrictHttpResponse<WalletCouponHalResponse>> {
    return addCoupon(this.http, this.rootUrl, params, context);
  }

  /**
   * Add a Coupon
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addCoupon$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addCoupon(params: AddCoupon$Params, context?: HttpContext): Observable<WalletCouponHalResponse> {
    return this.addCoupon$Response(params, context).pipe(
      map((r: StrictHttpResponse<WalletCouponHalResponse>): WalletCouponHalResponse => r.body)
    );
  }

  /** Path part for operation `getCouponById()` */
  static readonly GetCouponByIdPath = '/wallet/coupons/{couponId}';

  /**
   * Get Coupon by Id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCouponById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCouponById$Response(params: GetCouponById$Params, context?: HttpContext): Observable<StrictHttpResponse<WalletCouponHalResponse>> {
    return getCouponById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Coupon by Id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCouponById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCouponById(params: GetCouponById$Params, context?: HttpContext): Observable<WalletCouponHalResponse> {
    return this.getCouponById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WalletCouponHalResponse>): WalletCouponHalResponse => r.body)
    );
  }

  /** Path part for operation `updateCouponById()` */
  static readonly UpdateCouponByIdPath = '/wallet/coupons/{couponId}';

  /**
   * Update Coupon by Id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCouponById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCouponById$Response(params: UpdateCouponById$Params, context?: HttpContext): Observable<StrictHttpResponse<WalletCouponHalResponse>> {
    return updateCouponById(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Coupon by Id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCouponById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCouponById(params: UpdateCouponById$Params, context?: HttpContext): Observable<WalletCouponHalResponse> {
    return this.updateCouponById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WalletCouponHalResponse>): WalletCouponHalResponse => r.body)
    );
  }

  /** Path part for operation `deleteCouponById()` */
  static readonly DeleteCouponByIdPath = '/wallet/coupons/{couponId}';

  /**
   * Delete Coupon by Id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteCouponById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCouponById$Response(params: DeleteCouponById$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteCouponById(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Coupon by Id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteCouponById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCouponById(params: DeleteCouponById$Params, context?: HttpContext): Observable<void> {
    return this.deleteCouponById$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
